import { useEffect } from "react";
import { Logo } from "@/components/lunar/Logo";
import { Reveal } from "@/components/lunar/Reveal";
import { Footer } from "@/components/lunar/Footer";

export const LegalPage = ({ title, updated, intro = [], sections, prefix }) => {
    useEffect(() => {
        document.title = `${title} — Lunar`;
        return () => {
            document.title = "Lunar — The social network for real life";
        };
    }, [title]);

    return (
        <div data-testid={`${prefix}-page`}>
            <header className="mx-auto flex max-w-3xl items-center justify-between px-6 pt-7">
                <a href="/" aria-label="Back to Lunar home" data-testid={`${prefix}-back-home`}>
                    <Logo size={38} />
                </a>
            </header>
            <main className="mx-auto max-w-3xl px-6 pb-24 pt-16 sm:pt-20">
                <Reveal>
                    <p className="text-[11px] font-medium uppercase tracking-[0.28em] text-[#899B6A]">
                        Legal
                    </p>
                    <h1
                        data-testid={`${prefix}-heading`}
                        className="font-display mt-5 text-4xl font-medium leading-[1.08] tracking-tight text-[#1D201A] sm:text-5xl"
                    >
                        {title}
                    </h1>
                    {updated && (
                        <p data-testid={`${prefix}-updated`} className="mt-4 text-sm text-[#5C5F58]">
                            Last updated: {updated}
                        </p>
                    )}
                </Reveal>

                {intro.length > 0 && (
                    <Reveal delay={0.1} className="mt-10 space-y-5 border-t border-[#E5E3DC] pt-10">
                        {intro.map((p, i) => (
                            <p key={i} className="text-base leading-relaxed text-[#3E413B]">
                                {p}
                            </p>
                        ))}
                    </Reveal>
                )}

                {sections.map((section, i) => (
                    <Reveal key={section.title} className="mt-14">
                        <h2
                            data-testid={`${prefix}-section-${i + 1}`}
                            className="font-display text-2xl font-semibold text-[#1D201A]"
                        >
                            {section.title}
                        </h2>
                        <div className="mt-4 space-y-4">
                            {section.paragraphs?.map((p, j) => (
                                <p key={j} className="text-base leading-relaxed text-[#3E413B]">
                                    {p}
                                </p>
                            ))}
                            {section.list && (
                                <ul className="list-disc space-y-2 pl-5 text-base leading-relaxed text-[#3E413B] marker:text-[#899B6A]">
                                    {section.list.map((item, j) => (
                                        <li key={j}>{item}</li>
                                    ))}
                                </ul>
                            )}
                            {section.after && (
                                <p className="text-base leading-relaxed text-[#3E413B]">
                                    {section.after}
                                </p>
                            )}
                            {section.afterList?.map((p, j) => (
                                <p key={j} className="text-base leading-relaxed text-[#3E413B]">
                                    {p}
                                </p>
                            ))}
                        </div>
                    </Reveal>
                ))}
            </main>
            <Footer />
        </div>
    );
};
